module.exports = __webpack_public_path__ + "media/src/images/icon/sns/fb-4b190e151feb40e97cbd2ad98a48567a.png";